module.exports = __webpack_public_path__ + "static/media/Collapse Menu.6a852783.svg";